var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KSelect',{attrs:{"label":"Select an option","placeholder":"Choose an option...","options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }